import React from 'react';
import './DataAnalytics1.css';
import Image from '../../assets/Image';

export default function DataAnalytics1() {
  return (
    <><br /><br /><br /><br /><br /><br />
      <img
      style={{width:"100%"}}
        src={Image.bannerdaANDa}
        alt="Data Analytics Banner"
      // className="banner-image"
      />
      <div className="portfolio-container data-analyticsec">
        <div>
          {/* Banner */}

 

        
        
                  <div style={{backgroundColor:" #f7f7f7"}} >
<br/>
           
          <h3 className="sub-heading1">Expertise</h3>

          </div>

          <section className="section section-flex bg-expertise">
            <div className="text-content">
              <ul className="list">
                <li><strong>Microsoft Dynamics 365 Integration</strong>Hands-on experience in automating and managing financial data within D365 environments.</li>
                <li><strong>Excel VBA Automation</strong>Development of custom macros and scripts to reduce manual work, enhance data accuracy, and ensure seamless workflows.</li>
                <li><strong>Data Transformation and Reconciliation</strong>Structured raw accounting data into usable formats for reporting, validation, and analysis.</li>
                <li><strong>Accounting Template Design</strong>Built reusable and scalable Excel templates tailored to accounting functions including journals, balances, and ledgers.</li>
                <li><strong>Inventory and Asset Management</strong>Created intelligent systems to monitor inventory flow and fixed assets across operational periods.</li>
                <li><strong>Vendor & Customer Data Handling</strong>Automated balance calculations and reporting for customer and vendor accounts, including periodic updates and integrity checks.</li>
              </ul>
            </div>
            <div className="image-content">

              {/* <div style={{ marginTop: '80px' }} > */}
                <img src={Image.dataanalyticsimage1} alt="Expertise" className="side-image"  style={{width:"75%"}}  />
                
              {/* </div> */}

            </div>
          </section>

          {/* Key Contributions with image on left */}
          <h2 className="sub-heading1">Key Contributions</h2>
          <section className="section section-flex reverse bg-contributions">
            <div className="text-content">
              <ul className="list">
                <li><strong>Workflow Automation</strong>Automated end-to-end financial operations, including purchase order tracking, general ledger entries, and balance sheet generation.</li>
                <li><strong>Data Accuracy and Validation</strong>Implemented layered validation mechanisms to ensure consistency and compliance in financial reporting.</li>
                <li><strong>Continuous Optimization</strong>Regularly reviewed and enhanced existing systems based on user feedback, process changes, and business needs.</li>
              </ul>
            </div>
            <div className="image-content">
              <div style={{width:"60%"}} >
              {/* <img src={Image.peopel001} alt="Key Contributions" className="side-image" /> */}
              <img src={Image.aboutus1} alt="Current Focus" className="side-image" />

              </div>
            </div>
          </section>

          {/* Current Focus with image on right */}
          <div style={{backgroundColor:" #f7f7f7"}} >
<br/>
          <h2 className="sub-heading1">Current Focus</h2>

          </div>

          <section className="section section-flex bg-focus">
            <div className="text-content">
               <ul className="list">
                <li>Integrating revised financial data sources into existing templates.</li>
                <li>Refining automated workflows to align with real-time accounting updates.</li>
                <li>Preparing systems for smoother handoff to operational and audit teams.</li>
              </ul>
            </div>
            <div className="image-content">
              <div style={{width:"70%"}} >

              {/* <img src={Image.aboutus1} alt="Current Focus" className="side-image" /> */}
              <img src={Image.peopel001} alt="Key Contributions" className="side-image" />

            </div>
            </div>
          </section>

          {/* Project Highlights (unchanged) */}
          <h2 className="sub-heading1">Project Highlights</h2>
          <section className="section">
            <div className="projects-grid">
              {projectHighlights.map((proj, i) => (
                <div className="project-card" key={i}>
                  <img
                    src={proj.image}
                    alt={proj.title}
                    className="project-image"
                  />
                  <h3 className="project-title">{proj.title}</h3>
                  <p className="paragraph">{proj.description}</p>
                </div>
              ))}
            </div>
          </section>
        </div>
      </div>
    </>
  );
}

const projectHighlights = [
  {
    title: "Vendor Master Automation",
    image: Image.Imagedataanalytics,
    description: "Streamlined vendor detail management with periodic validations.",
  },
  {
    title: "Customer Reconciliation",
    image: Image.vender,
    description: "Automated balance reporting with data transformation techniques.",
  },
  {
    title: "Fixed Asset Tracker",
    image: Image.localhost11,
    description: "Built dynamic asset tracking templates for monthly depreciation reports.",
  },
];
